const body = document.querySelector("body");
window.onload = () => {
  body.classList.remove("loading"),
    gsap.from(body, { opacity: 0, duration: 1, ease: "power3.inOut" });
};
gsap.from("#Layera_1", {
  duration: 1,
  y: "100",
  ease: "power3.inOut",
  opacity: 0,
  delay: 0,
});

gsap.from("#doctor-hand", {
  duration: 1,
  y: "101",
  ease: "power3.inOut",
  opacity: 0,
  delay: 0,
});
gsap.from("#imac", {
  duration: 1,
  x: "100",
  ease: "power3.inOut",
  opacity: 0,
  delay: 2,
});
gsap.from("#man-foreground", {
  duration: 1,
  y: "100",
  ease: "power3.inOut",
  opacity: 0,
  delay: 1,
});
gsap.from(".hero-bg-pat", {
  duration: 1,
  ease: "power3.inOut",
  opacity: 0,
  delay: 1,
  x: "20",
});
gsap.from(".welcome-to-text", {
  duration: 1,
  ease: "power3.inOut",
  opacity: 0,
  delay: 0.2,
  y: "50",
});
gsap.from(".hero-to-text", {
  duration: 1,
  ease: "power3.inOut",
  opacity: 0,
  delay: 0.4,
  x: "-50",
});
gsap.from(".hero-to-button", {
  duration: 1,
  ease: "power3.inOut",
  opacity: 0,
  delay: 0.6,
  x: "-50",
});

// Scroll Trigger Stuff
const textBlock = gsap.utils.toArray(".text-anim");
textBlock.forEach((text, i) => {
  ScrollTrigger.create({
    trigger: text,
    toggleClass: "active",
    start: "top 70%",
    end: "bottom 15%",
    //markers: true,//
  });
});
const textBlockUp = gsap.utils.toArray(".text-up-anim");
textBlockUp.forEach((text, i) => {
  ScrollTrigger.create({
    trigger: text,
    toggleClass: "active",
    start: "top 90%",
    end: "bottom 15%",
    //markers: true,//
  });
});
const infoSteps = gsap.utils.toArray("#infographic-steps-text");
infoSteps.forEach((text, i) => {
  ScrollTrigger.create({
    trigger: text,
    toggleClass: "active",
    start: "top 80%",
    end: "bottom 20%",
    delay: "1s",
    //markers: true,//
  });
});
const textFade = gsap.utils.toArray(".fade");
textFade.forEach((text, i) => {
  ScrollTrigger.create({
    trigger: text,
    toggleClass: "active",
    start: "top 70%",
    end: "bottom 15%",
    //markers: true,//
  });
});
const imgRight = gsap.utils.toArray(".img-right");
imgRight.forEach((text, i) => {
  ScrollTrigger.create({
    trigger: text,
    toggleClass: "active",
    start: "top 70%",
    end: "bottom 15%",
    //markers: true,//
  });
});
const textFadeAlt = gsap.utils.toArray(".fade-alt");
textFadeAlt.forEach((text, i) => {
  ScrollTrigger.create({
    trigger: text,
    toggleClass: "active",
    start: "top 70%",
    end: "bottom 15%",
    //markers: true,//
  });
});

const mouse = document.querySelector(".cursor"),
  mouse2 = document.querySelector(".cursor2");

if (mouse && mouse2) {
  const links = document.querySelectorAll("a");

  document.addEventListener("mousemove", function (e) {
    mouse.style.cssText = mouse2.style.cssText =
      "left: " + e.clientX + "px; top: " + e.clientY + "px;";
  });

  links.forEach((link) => {
    link.addEventListener("mouseleave", () => {
      mouse.classList.remove("cursor-change"),
        mouse2.classList.remove("inner-hidden"),
        link.classList.remove("link-change");
    }),
      link.addEventListener("mouseover", () => {
        mouse.classList.add("cursor-change"),
          mouse2.classList.add("inner-hidden"),
          link.classList.add("link-change");
      });
  });
}

if (window.jQuery && $.fn.slick) {
  $(function () {
    if ($(".customer-logos").length) {
      $(".customer-logos").slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 520,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    if ($(".customer-testimonials").length) {
      $(".customer-testimonials").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        fade: true,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 520,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  });
}
